import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, { username, password });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};

// Portal (Applicant) auth services
export const portalLogin = async (username, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/portal/auth/login`, { username, password });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};

export const portalForgotPassword = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/portal/auth/forgot-password`, { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};

export const portalResetPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/portal/auth/reset-password`, { token, newPassword });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};

export const portalChangePassword = async (currentPassword, newPassword, accessToken) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/portal/auth/change-password`,
      { currentPassword, newPassword },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};

// Admin/Community auth services
export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/reset-password`, { token, newPassword });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Network error');
  }
};